<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import ModuleTitle from '@/components/layout/ModuleTitle'
  import OverlayGallery from '@/components/overlays/OverlayGallery'

  export default {
    name: 'GalleryModule',
    components: {
      swiper,
      swiperSlide,
      OverlayGallery,
      ModuleTitle,
    },
    props: {
      // only get prop options key
      options: {
        type: Object,
        default: _ => {},
      },
      moduleId: Number,
    },
    data() {
      return {
        currentSlide: 0,
        overlayIndex: null,
        swiperOption: {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 10,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: `.next-${this.moduleId}`,
            prevEl: `.prev-${this.moduleId}`,
          },
          on: {
            slideChange: () => this.updateSlide(),
          },
        },
      }
    },
    methods: {
      clickSwiper(event) {
        this.overlayIndex = parseInt(event.target.parentElement.getAttribute('data-swiper-slide-index'))
      },
      closeOverlay() {
        this.overlayIndex = null
      },
      updateSlide() {
        this.currentSlide = this.$refs.swiper.swiper.realIndex
      },
    },
  }
</script>
